
import { Action, Getter } from 'vuex-class'
import { Component, Vue, Watch } from 'vue-property-decorator'
import AppendixDialog from '@/views/orderManage/template/AppendixDialog.vue'
import DatetimePickerDialog from '@/views/orderManage/template/DatetimePickerDialog.vue'
import DistributionWayPickerDialog from '@/views/orderManage/template/DistributionWayPickerDialog.vue'
import HandleFlowDialog from '@/views/orderManage/template/HandleFlowDialog.vue'
import SelectGoods from '@/views/orderManage/template/SelectGoods.vue'
import {
    cancelOrderApi,
    confirmRecieve,
    PreRtnOrderInfoDto,
    purchaseGoodsAgain,
    ReturnOrderDtlDto,
    ShopOrderInfoDto,
    verifyReturnOrderDtl
} from '@/api/shopOrder'
import {
    getOrderInfo,
    OrderListDto,
    updateOrderStatus,
    updateOrderPayStatus,
    modifyOrder,
    backOrder,
    getOrderOrReturnNodeList,
    getOrderRemarkList,
    modifyOrderAttachFile,
    purchaseOrderAgainAppApi
} from '@/api/order'
import ServiceLine from '@/views/financial/template/ServiceLine.vue'
import AppendixName from '@/components/AppendixName/index.vue'
import StepTemp from '@/components/StepTemp/index.vue'
import {
    GoodsListOfCategoryFormatDto,
    SelectGoodsOptionsDto
} from '@/api/commonConfig'
import math from '@/core/math'
import { backToBefore,backHomes } from '@/utils/h5ToApp'
import { toNumber } from 'lodash'
import { getCompanyLine, ServiceLineListDto, upFile } from '@/api/commonConfig'
import Clipboard from 'clipboard'

@Component({
    name: 'purchaseOrderDetail',
    components: {
        AppendixDialog,
        DatetimePickerDialog,
        DistributionWayPickerDialog,
        AppendixName,
        SelectGoods,
        HandleFlowDialog,
        StepTemp,
        ServiceLine
    }
})
export default class purchaseOrderDetail extends Vue {
    @Getter companyId!: string
    @Getter selectList!: SelectGoodsOptionsDto[]
    @Action setSelectList!: (val: SelectGoodsOptionsDto[]) => void
    @Action setOrderFromPage!:(val: string) => void

    showPopover = false

    // 订单信息对象
    orderInfo: ShopOrderInfoDto = {
        // 初始值
        payFreight: 0,
        orderTotalMoney: 0
    }

    orderId = ''
    currRouteId = ''
    serviceLineList: ServiceLineListDto[] = []
    // 是否初始化获取数据完成
    isInit = false
    // 是否修改订单信息对象
    isUpdateOrderInfo = false
    // 进度条数据
    stepList: any[] = []
    params: {
        orderId?: string;
        customerId?: string;
        companyId?: string;
        shopId?: string;
        currRouteId?: string;
    } = {}
    isEdit = false
    isEditOrder = false // 是否是修改订单状态
    fromPage = '' // fromPage=='1'的时候，说明是原生跳转过来的，此时，返回按钮需要调用原生返回方法

    selectGoodsList: GoodsListOfCategoryFormatDto[] = []

    @Watch('orderInfo', {deep: true, immediate: true})
    onOrderInfoChange (newVal, oldVal) {
        if (this.isInit) {
            this.isUpdateOrderInfo = true
        }
    }

    @Watch('orderInfo.payFreight', {deep: true, immediate: true})
    payFreightChange (val: string) {
        this.orderInfo.orderMoney = Number(
            math.mathAdd(this.orderInfo.orderTotalMoney, val)
        )
    }

    activated () {
        this.getRemarkList()
        if (this.$route.query.fromPath === '1') {
            this.getRemarkList()
        } else if (this.$route.query.fromPath === '2') {
            this.orderInfo.orderTotalMoney = Number(
                this.$route.query.totalPrice as string
            )
            this.orderInfo.orderTotalMoney = Number(
                this.$route.query.totalPrice as string
            )
            this.orderInfo.orderMoney = Number(
                math.mathAdd(this.orderInfo.orderTotalMoney, this.orderInfo.payFreight)
            )
            this.selectGoodsList = this.selectList

        }
        this.fromPage = this.$route.query.fromPage ? (this.$route.query.fromPage as string) : '0'
        if(this.fromPage==='1') this.setOrderFromPage('1')
    }

    /* 联系店家 */
    showServiceLine () {
        (this.$refs.serviceLine as any).show()
    }

    /**
     * 再次购买
     */
    buyAgain () {
        // if (!this.$action('buyAgainDetail')) {
        //     return false
        // }
        purchaseGoodsAgain(this.params)
            .then(() => {
                this.$toast.success('已添加至购物车')
            })
            .catch(() => {})
    }

    /**
     * 确认收货
     */
    confirmOrder () {
        // if (!this.$action('confirmOrder')) {
        //     return false
        // }
        confirmRecieve(this.params)
            .then((res) => {
                let msg = ''
                if (res.code === '000000') {
                    msg = '确认收货成功'
                } else if (res.code === '000002') {
                    msg = '订货单状态已变更'
                }
                this.$dialog
                    .alert({
                        message: msg
                    })
                    .then(() => {
                        this.getInfo()
                    })
            })
            .catch(() => {})
    }

    /* 取消订单 */
    cancelOrder () {
        // if (!this.$action('cancelOrder')) {
        //     return false
        // }
        cancelOrderApi(this.params).then((res) => {
            let msg = ''
            if (res.code === '000000') {
                msg = '取消订单成功'
            } else if (res.code === '000002') {
                msg = '订货单状态已变更，不可取消订单'
            }
            this.$dialog
                .alert({
                    message: msg
                })
                .then(() => {
                    this.getInfo()
                })
        })
    }

    handleBack () {
        if (this.fromPage === '1') {
            backToBefore()
        } else {
            this.$router.back()
        }
    }

    /**
     * @description: 监听复制
     * @param {*} e 复制内容
     * @return {*}
     */
    copyCode (key) {
        let clipboard = new Clipboard('.copy', {
            text: trigger => key
        })
        clipboard.on('success', e => {
            this.$toast('复制成功')
        })
        clipboard.on('error', e => {
            this.$toast('该浏览器不支持复制')
            e.clearSelection()
        })
    }


    /**
     * @description: 获取备注页数据
     * @param {*}
     * @return {*}
     */
    getRemarkList () {
        let obj = {
            companyId: this.companyId,
            currRouteId: this.params.currRouteId,
            orderId: this.params.orderId,
            orderType: '1'
        }
        getOrderRemarkList(obj).then((res) => {
            this.$set(
                this.orderInfo,
                'orderRemarkList',
                (res.data && res.data.orderRemark) || []
            )
        })
    }

    toAppendix () {
        let orderInfo = this.orderInfo
        let params = {
            fileType: '6' ,// 订单附件
            orderFile: orderInfo.orderFileList,
            orderId: orderInfo.orderId,
            currRouteId: orderInfo.currRouteId,
            type:'1' // 1订单 2退单
        };
        (this.$refs.appendix as any).show(params)
    }

    /**
     * @description: 获取附件信息
     * @param {*} fileInfo
     * @return {*}
     */
    getFileInfo (fileInfo) {
      this.$set(this.orderInfo, 'orderFileList', fileInfo)
    }

    toRemarks () {
        let query = this.$route.query
        this.$router.push({
            path: '/remarks',
            query: {
                orderId: query.orderId,
                currRouteId: query.currRouteId,
                orderType: '1' // 1:订货单 2:退货单
            }
        })
    }

    toLog () {
        this.$router.push({
            path: '/log',
            query: {
                currRouteId: this.params.currRouteId,
                orderId: this.params.orderId
            }
        })
    }

    // 调用原生enterSelectAddress方法去选择收获地址
    toSelectAddress () {
        if (this.orderInfo.orderStatus === 1 && this.isEditOrder) {
            const data = {
                customerId: this.orderInfo.customerId,
                isShowTemporary: false, // 是否展示临时地址信息 传false就是不展示，true就是展示
                title: '选择收货地址'
            }
            this.$bridge.callHandler('enterSelectAddress', {data}, (res) => {
                const data = !res ? {} : JSON.parse(res)
                this.orderInfo.receiveMan = data.receiveMan
                this.orderInfo.receiveMobile = data.receiveMobile
                this.orderInfo.receiveAddress = data.addressId
                this.orderInfo.addressFullName = data.addressName
                this.orderInfo.receiveAddressDtl = data.addressDtl
            })
        }
    }

    valetRefund () {
        let query = this.$route.query
        this.$router.push({
            path: '/valetRefund',
            query: {
                orderId: query.orderId, // 订单id（也可以orderInfo拿）
                currRouteId: query.currRouteId // 分区序号
            }
        })
    }

    /**
     * @description: 删除订单
     * @param {*}
     * @return {*}
     */
    deleteOrder () {
        this.showPopover = false
        this.$dialog
            .confirm({
                title: '温馨提示',
                message: '是否确认删除当前订单?'
            })
            .then(() => {
                let query = this.$route.query
                let orderIdList = [
                    {
                        orderId: query.orderId, // 订单id（也可以orderInfo拿）
                        currRouteId: query.currRouteId // 分区序号
                    }
                ]
                let params = {
                    companyId: this.companyId,
                    operateType: 7, // 删除
                    orderIdList
                }
                updateOrderStatus(params).then((res) => {
                    this.$toast({
                        type: 'success',
                        message: '删除成功',
                        duration: 1000,
                        onClose: () => {
                            this.$router.back()
                            this.$eventBus.$emit('orderDetail')
                        }
                    })
                })
            })
            .catch(() => {
                console.log('取消')
            })
    }

    /**
     * @description: 修改期望交货日期
     * @param {*}
     * @return {*}
     */
    updateDeliveryDate () {
        // 仅待订单审核状态下可修改
        if (this.orderInfo.orderStatus === 1) {
            (this.$refs.datetimePicker as any).show()
        }
    }

    /**
     * @description: 获取期望交货日期
     * @param {*} dateTime
     * @return {*}
     */
    getDeliveryDate (dateTime) {
        this.$set(this.orderInfo, 'deliveryDate', dateTime)
    }

    /**
     * @description: 修改配送方式
     * @param {*}
     * @return {*}
     */
    updateDistributionWay () {
        // 仅待订单审核状态下可修改
        if (this.orderInfo.orderStatus === 1 && this.isEditOrder) {
            (this.$refs.distributionWayPicker as any).show(
                this.orderInfo.distributionWay
            )
        }
    }

    /**
     * @description: 获取配送方式
     * @param {*} obj 数据字典数据
     * @return {*}
     */
    getDistributionWay (obj) {
        this.orderInfo.distributionWay = obj.dataId
        this.orderInfo.distributionWayName = obj.dataName
    }

    /**
     * @description: 修改商品清单
     * @param {*}
     * @return {*}
     */
    updateGoods () {
        let orderDtlSelect = this.orderInfo.orderDtlList.map((item) => {
            return {
                ...item,
                isChecked: true
            }
        });
        (this.$refs.selectGoods as any).show(
            this.orderInfo.orderDtlList,
            orderDtlSelect,
            '修改订单商品'
        )
    }

    /* 修改商品选择商品清单 */
    chooseGoods () {
        window.sessionStorage.setItem('toPath', this.$route.path)
        this.$router.push({
            path: '/chooseGoods',
            query: {
                customerId: this.orderInfo.customerId
            }
        })
    }

    /**
     * @description: 获取商品清单
     * @param {*}
     * @return {*}
     */
    getGoods (data) {
        this.orderInfo.orderDtlList = data
    }

    /*
     * 附件修改
     * */
    modifyOrderAttachFile (count) {
        const params = {
            companyId: this.companyId,
            orderType: '1', // 1:订货单 2:退货单
            orderId: this.orderInfo.orderId,
            currRouteId: this.orderInfo.currRouteId,
            orderFileUrl: count.filePath,
            orderFileName: count.fileName,
            orderFileSize: count.fileSize
        }
        modifyOrderAttachFile(params).then((res: any) => {
            if (res.code === '000000') {
                console.log('修改成功')
            } else {
                this.$toast(res.msg)
            }
        })
    }

    /**
     * @description: 保存修改订单
     * @param {*}
     * @return {*}
     */
    saveOrder () {
        let params = {
            companyId: this.companyId,
            ...this.orderInfo,
            purchaseOrderDtlList: this.selectGoodsList.map((item) => {
                return {
                    versionId: item.versionId,
                    goodsId: item.goodsId,
                    packageId: item.packageId,
                    saleAmount: item.saleAmount
                }
            })
            // purchaseOrderDtlList: this.orderInfo.orderDtlList
        }
        delete params.orderDtlList
        delete params.orderRemarkList
        modifyOrder(params).then((res) => {
            this.$toast({
                type: 'success',
                message: '保存成功',
                duration: 1000,
                onClose: () => {
                    this.isEditOrder = false
                    // 刷新订单信息对象
                    this.reloadInfo()
                }
            })
        })
    }

    /**
     * @description: 再来一单事件
     * @param {*}
     * @return {*}
     */
    toPlaceOrder () {
        const obj = {
            companyId: this.companyId,
            orderId: this.params.orderId,
            currRouteId: this.params.currRouteId
        }
        purchaseOrderAgainAppApi(obj).then((res) => {
            if (res.code === '000000') {
                this.$router.push({
                    path: '/valetOrder',
                    query: {
                        orderId: this.params.orderId,
                        currRouteId: this.params.currRouteId,
                        placeType: '2' // '2'为再来一单
                    }
                })
            }
        })
    }

    /**
     * @description: 操作方法
     * @param {*操作类型：1：订单审核2：出库确认3：发货确认6：作废7：删除8：付款确认 9:退回} operateType
     * @param {*操作对象} obj
     * @return {*}
     */
    handleOperation (operateType) {
        if (!this.$action(`updateOrderStatus${operateType}`)) {
            return false
        }
        let title
        let message
        let isRequired // 备注是否必填
        let isNumberInput // 确认收付款改为number输入框判断是否显示number输入框
        switch (operateType) {
            case 1:
                title = '订单审核'
                message = '是否确认订单审核通过？'
                isRequired = false
                isNumberInput = false
                break
            case 2:
                title = '出库确认'
                message = '是否确认出库？'
                isRequired = false
                isNumberInput = false
                break
            case 3:
                title = '发货确认'
                message = '是否确认发货？'
                isRequired = false
                isNumberInput = false
                break
            case 6:
                title = '作废确认'
                message = '是否确认作废订单？'
                isRequired = true
                isNumberInput = false
                break
            case 8:
                title = '确认收款'
                message = '是否确认订单收款完成？'
                isRequired = false
                isNumberInput = true
                break
            case 9:
                title = '退回确认'
                message = '是否确认退回订单重新审核？'
                isRequired = true
                isNumberInput = false
                break
        }
        (this.$refs.handleFlow as any).show({
            title,
            message,
            operateType,
            isRequired,
            isNumberInput
        })
    }

    /**
     * @description: 修改订货单状态方法
     * @param {*请求参数} params
     * @param {*提示} tips
     * @return {*}
     */
    updateOrderStatus (params, successTips) {
        updateOrderStatus(params).then((res) => {
            this.$toast({
                type: 'success',
                message: `${successTips}`,
                duration: 1000,
                onClose: () => {
                    // 刷新订单信息对象
                    this.reloadInfo()
                }
            })
        })
    }

    /**
     * @description: 修改订货单付款状态方法
     * @param {*请求参数} params
     * @param {*提示} tips
     * @return {*}
     */
    updateOrderPayStatus (params, successTips) {
        updateOrderPayStatus(params).then((res) => {
            this.$toast({
                type: 'success',
                message: `${successTips}`,
                duration: 1000,
                onClose: () => {
                    // 刷新订单信息对象
                    this.reloadInfo()
                }
            })
        })
    }

    handleFlowConfirm ({remark, operateType}) {
        // 成功提示
        let successTips
        switch (operateType) {
            case 1:
                successTips = '订单审核通过'
                break
            case 2:
                successTips = '订单出库成功'
                break
            case 3:
                successTips = '订单发货成功'
                break
            case 6:
                successTips = '订单作废成功'
                break
            case 8:
                successTips = '确认付款完成'
                break
            case 9:
                successTips = '退回成功'
                break
        }
        // 处理获取请求参数
        let query = this.$route.query
        if (operateType === 9) {
            // 退回
            let params = {
                companyId: this.companyId,
                orderId: query.orderId,
                currRouteId: query.currRouteId,
                Remark: remark
            }
            backOrder(params).then((res) => {
                this.$toast({
                    type: 'success',
                    message: `${successTips}`,
                    duration: 1000,
                    onClose: () => {
                        // 刷新订单信息对象shouhuo
                        this.reloadInfo()
                    }
                })
            })
        } else if (operateType === 8) {
            let params = {
                companyId: this.companyId,
                currRouteId: query.currRouteId,
                orderId: query.orderId,
                orderType: 1,
                money: toNumber(remark)
            }
            this.updateOrderPayStatus(params, successTips)
        } else {
            let orderIdList = [
                {
                    currRouteId: query.currRouteId,
                    orderId: query.orderId
                }
            ]
            let params = {
                companyId: this.companyId,
                operateType,
                orderIdList,
                orderRemark: remark
            }
            this.updateOrderStatus(params, successTips)
        }
        this.reloadInfo()
    }

    /**
     * @description: 获取进度条数据
     * @param {*}
     * @return {*}
     */
    getStepList () {
        let params = {
            orderId: this.orderInfo.orderId,
            currRouteId: this.orderInfo.currRouteId
        }
        getOrderOrReturnNodeList(params).then((res) => {
            const list = res.data.nodeIdList || []
            this.stepList = list.map((item: any) => {
                return {
                    key: item.nodeId,
                    title: item.nodeName.replace('【客户】', '') // 将'【客户】'去掉，避免title过长
                    // isValid: item.isValid
                }
            })
        })
    }

    /**
     * @description: 获取订单详情信息
     * @param {*}
     * @return {*}
     */
    getInfo () {
        this.isInit = false
        this.isUpdateOrderInfo = false
        // 采购单
        getOrderInfo(this.params).then((res) => {
            this.orderInfo = res.data
            this.params.orderId = this.orderInfo.orderId
            this.params.customerId = this.companyId
            this.params.companyId = this.companyId
            this.params.shopId = res.data.shopCompanyId
            this.params.currRouteId = res.data.currRouteId
            this.getServiceLine(this.orderInfo.shopCompanyId)
            console.log(123, this.params)
            this.selectGoodsList = res.data.orderDtlList.map((item) => {
                return {
                    goodsId: item.goodsId,
                    goodsName: item.goodsName,
                    imageNameUrl: item.packageMainImage,
                    versionId: item.versionId,
                    saleAmount: item.saleAmount,
                    orderPrice: item.salePrice,
                    packageId: item.setmealId,
                    maximum: item.maximum,
                    minimum: item.minimum,
                    // packageName: item.packageName,
                    packageNameDesc: item.packageNameDesc
                }
            })
            this.setSelectList(this.selectGoodsList)
            // 获取进度条数据
            this.getStepList()
            this.$nextTick(() => {
                this.isInit = true
            })
        })
    }

    // 刷新订单信息对象
    reloadInfo () {
        window.sessionStorage.setItem('isRefresh', '1')
        this.getInfo()
    }

    created () {
        let query = this.$route.query
        this.orderId = this.$route.query.orderId as string
        this.currRouteId = this.$route.query.currRouteId as string
        this.params = {
            companyId: this.companyId,
            orderId: query.orderId as string, // 订单id
            currRouteId: query.currRouteId as string // 分区序号
        }

        this.fromPage = query.fromPage ? (query.fromPage as string) : '0'

        if(this.fromPage==='1') this.setOrderFromPage('1')
        // 获取订单详情信息
        this.getInfo()
    }

    /**
     *  需求2.0 取消采购单详情的分享功能
     *  以下函数暂时无效
     */
    shareOrder () {
        // if (!this.$action('orderShare')) {
        //     return false
        // }
        const data = {
            title: '订单详情',
            content: '分享的内容',
            url: `http://172.16.101.69:8086/orderDetail?orderId=${this.params.orderId}&currRouteId=${this.params.currRouteId}`
        }
        this.showPopover = false
        // 定时器是为了去掉动画关闭的时间
        setTimeout(() => {
            this.$bridge.callHandler('screenshot', {data}, (res) => {
                console.log('分享成功')
            })
        }, 300)
    }

    /**
     * 格式化金额 仅可录入数字，最少为0.00，最大为99999999.99
     * @param value
     */
    formatterMoney (value) {
        if (value) {
            value = Number(value) > 99999999.99 ? '99999999.99' : value
        } else {
            value = '0'
        }
        return value
            .replace(/0*(\d+)/, '$1')
            .replace(/[^0-9.]/g, '')
            .replace(/^(\\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    }

    editAmount () {
        this.isEdit = true
        this.$nextTick(() => {
            (this.$refs.payFreight as any).focus()
        })
    }

    cancelSave () {
        this.$confirmDialog.show({
            okText: '确认',
            cancelText: '取消',
            tips: '取消后修改的内容不会保存，是否确认取消修改？',
            onOk: () => {
                this.isEditOrder = false
                this.setSelectList([])
                return this.$router.back()
            }
        })
    }

    /* 获取服务热线 */
    getServiceLine (id: string) {
        getCompanyLine({companyId: id}).then((res) => {
            this.serviceLineList = (res.data && res.data.serviceLineList) || []
        })
    }

    /* 申请退货 */
    applyReturnGoods () {
        let arr = []
        this.orderInfo.orderDtlList.forEach((item) => {
            if (item.returnSaleAmount) {
                arr.push({
                    orderDtlId: item.orderDtlId,
                    returnAmount: item.returnSaleAmount
                })
            }
        })
        if (arr && arr.length > 0) {
            const obj = {
                orderId: this.orderId,
                currRouteId: this.currRouteId,
                returnOrderDtlList: arr
            }
            verifyReturnOrderDtl(obj)
                .then((res) => {
                    if (res.code === '000000') {
                        const data = res.data
                        if (data && data.returnable) {
                            this.$router.push({
                                path: '/choosePackage',
                                query: {
                                    orderId: this.orderInfo.orderId,
                                    currRouteId: String(this.orderInfo.currRouteId)
                                }
                            })
                        } else {
                            this.$toast.fail({
                                message: '该订货单不可退货，请重新选择',
                                duration: 1500,
                                onClose: () => {
                                    this.getInfo()
                                }
                            })
                        }
                    }
                })
                .catch(() => {})
        } else {
            this.$toast('此订单没有可退的商品')
        }
    }
}
